export default __webpack_public_path__ + "static/media/vuesax_outline_close-circle.1342704e.svg";